"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluginDebugStr = void 0;
/**
 * Returns string that identifies a concrete plugin and can be used in log messages.
 *
 * @internal
 */
function pluginDebugStr(plugin) {
    var _a;
    return ((_a = plugin.debugName) !== null && _a !== void 0 ? _a : plugin.displayName) + "/" + plugin.version;
}
exports.pluginDebugStr = pluginDebugStr;
//# sourceMappingURL=pluginUtils.js.map